import _get from 'lodash/get';
import { IDiscoverData, IDiscoverUnavailableData } from 'shared/models';

export const DiscoverUtil = {
  Libra: {
    shouldUseSortModel: (parameters: unknown) => Boolean(_get(parameters, 'seo_web.seo_sort_model_webid', 0)),
    shouldFormatAsArticleDetail: (parameters: unknown) => Boolean(_get(parameters, 'seo_web.kep_immersive', 0)),
  },
  isDiscoverDataAvailable: (input: IDiscoverData | IDiscoverUnavailableData): input is IDiscoverData => {
    return !('unavailableReason' in input);
  },
};
